<template>
  <div id="activity-audits">
    <el-row :gutter="40">
      <el-col :span="24">
        <el-row class="header-row">
          <h3 class="el-page-header">Activity Audits</h3>
        </el-row>

        <el-popover placement="right" ref="newActivityAuditTypePopover" title="New Activity Audit" width="300" trigger="click">
          <el-form :model="addActivityAuditTypeForm" ref="addActivityAuditTypeForm" size="mini" :rules="addActivityAuditTypeForm.rules" label-position="top" label-width="180px" @submit.native.prevent>
            <el-form-item prop="name" label="Name">
              <el-input v-model="addActivityAuditTypeForm.name" size="mini"></el-input>
            </el-form-item>
            <el-form-item prop="description" label="Description">
              <el-input v-model="addActivityAuditTypeForm.description" size="mini"></el-input>
            </el-form-item>
            <el-form-item style="text-align: center;">
              <el-button-group>
                <el-button class="hiaButton" plain round size="mini" type="text" @click="closeNewActivityAuditTypePopover()">Cancel</el-button>
                <el-button class="hiaButton" plain round size="mini" @click="addType('addActivityAuditTypeForm')">Add</el-button>
              </el-button-group>
            </el-form-item>
          </el-form>

          <el-button class="hiaButton" slot="reference" plain round size="mini" icon="el-icon-plus">Add Activity Audit</el-button>
        </el-popover>

        <v-client-table class="hiaTable topMargin" v-loading="loading" element-loading-spinner="atom-audit-loader" ref="activityAuditTypesGrid" id="activityAuditTypesGrid" :data="activityAuditTypes" :columns="typeColumns" :options="typeOptions">
          <div slot="filter__isInactive">
            <input type="checkbox" @change="$refs.activityAuditTypesGrid.setFilter({ isInactive: $event.target.checked })" />
          </div>

          <div slot="filter__isInpatient">
            <input type="checkbox" @change="$refs.activityAuditTypesGrid.setFilter({ isInpatient: $event.target.checked })" />
          </div>

          <div slot="filter__isOutpatient">
            <input type="checkbox" @change="$refs.activityAuditTypesGrid.setFilter({ isOutpatient: $event.target.checked })" />
          </div>

          <div slot="filter__isAmbulatory">
            <input type="checkbox" @change="$refs.activityAuditTypesGrid.setFilter({ isAmbulatory: $event.target.checked })" />
          </div>

          <div slot="filter__isPro">
            <input type="checkbox" @change="$refs.activityAuditTypesGrid.setFilter({ isPro: $event.target.checked })" />
          </div>

          <template slot="drilldown" slot-scope="props">
            <span class="drilldown-cell">
              <span class="drilldown-toggle" @click="drilldown(props)" title="Expand or collapse">
                <i class="mdi" :class="props.row.selected ? 'mdi-minus-box-outline' : 'mdi-plus-box-outline'" style="font-size: 15px; position: relative; top: 1px;"></i>
              </span>
              <el-tag size="mini" type="primary" class="drilldown-tag" @click.native="openDrilldownTab(props, 'activities')"> Activities ({{ (props.row.activities || []).length }}) </el-tag>
              <el-tag size="mini" type="primary" class="drilldown-tag" @click.native="openDrilldownTab(props, 'reasons')"> Reasons for Change ({{ reasonsCountForType(props.row) }}) </el-tag>
            </span>
          </template>

          <template slot="child_row" slot-scope="props">
            <div style="padding-right: 20px; padding-left: 20px; padding-bottom: 20px; padding-top: 10px;">
              <el-row>
                <el-col :span="12">
                  <el-tabs v-model="activeTab" type="card">
                    <el-tab-pane label="Activities" name="activities">
                      <activities :selectedType="props.row" style="margin-top: -10px;"></activities>
                    </el-tab-pane>
                    <el-tab-pane label="Reasons for Change" name="reasons">
                      <activity-audit-reasons-for-change :selectedType="props.row" style="margin-top: -10px;"></activity-audit-reasons-for-change>
                    </el-tab-pane>
                  </el-tabs>
                </el-col>
              </el-row>
              <!--
              <el-row :gutter="40">
                <el-col :span="12">
                  <h3>{{ props.row.name }} Activities</h3>
                  <activities :selectedType="props.row"></activities>
                </el-col>
                <el-col :span="12">
                  <h3>Reason for Change Associations</h3>
                  <activity-audit-reasons-for-change :selectedType="props.row"></activity-audit-reasons-for-change>
                </el-col>
              </el-row> -->
              <!-- <el-collapse>
                <el-collapse-item title="Activities" name="activities">
                  <activities :selectedType="props.row"></activities>
                </el-collapse-item>
                <el-collapse-item title="Reasons for Change" name="reasons">
                  <activity-audit-reasons-for-change :selectedType="props.row"></activity-audit-reasons-for-change>
                </el-collapse-item>
              </el-collapse> -->
            </div>
          </template>

          <template slot="name" slot-scope="props">
            <div class="el-input--mini">
              <input class="el-input__inner" type="text" v-model="props.row.name" @change="updateType(props.row)" />
            </div>
          </template>

          <template slot="description" slot-scope="props">
            <div class="el-input--mini">
              <input class="el-input__inner" type="text" v-model="props.row.description" @change="updateType(props.row)" />
            </div>
          </template>

          <template slot="isInpatient" slot-scope="props">
            <input :key="props.row.activityAuditTypeId" type="checkbox" v-model="props.row.isInpatient" @change="updateType(props.row)" />
          </template>

          <template slot="isOutpatient" slot-scope="props">
            <input :key="props.row.activityAuditTypeId" type="checkbox" v-model="props.row.isOutpatient" @change="updateType(props.row)" />
          </template>

          <template slot="isAmbulatory" slot-scope="props">
            <input :key="props.row.activityAuditTypeId" type="checkbox" v-model="props.row.isAmbulatory" @change="updateType(props.row)" />
          </template>

          <template slot="isPro" slot-scope="props">
            <input :key="props.row.activityAuditTypeId" type="checkbox" v-model="props.row.isPro" @change="updateType(props.row)" />
          </template>

          <template slot="isInactive" slot-scope="props">
            <input :key="props.row.activityAuditTypeId" type="checkbox" v-model="props.row.isInactive" @change="updateType(props.row)" />
          </template>

          <template slot="delete" slot-scope="props">
            <div style="text-align: center;">
              <i class="el-icon-close delete-button" @click="deleteType(props.row)"></i>
            </div>
          </template>
        </v-client-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import hiaTable from '@/mixins/hiaTable'
  import activities from './activities'
  import activityAuditReasonsForChange from './activityAuditReasonsForChange'

  export default {
    name: 'ActivityAudits',
    mixins: [hiaTable, HiaAuthorization],
    props: [],
    data() {
      return {
        loading: false,
        typeColumns: ['drilldown', 'name', 'description', 'isInpatient', 'isOutpatient', 'isAmbulatory', 'isPro', 'isInactive', 'delete'],
        typeOptions: {
          showChildRowToggler: false,
          uniqueKey: 'activityAuditTypeId',
          filterByColumn: true,
          sortable: ['name'],
          filterable: ['drilldown', 'name', 'description'],
          headings: {
            delete: function(h) {
              return ''
            },
            drilldown: 'Activities',
            name: 'Name',
            isInpatient: 'Inpatient',
            isOutpatient: 'Outpatient',
            isAmbulatory: 'Ambulatory',
            isPro: 'Pro',
            isInactive: 'Inactive'
          },
          perPage: 10,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' },
          columnsClasses: {
            drilldown: 'drilldown'
          }
        },
        addActivityAuditTypeForm: {
          name: '',
          description: '',
          rules: {
            name: [{ required: true, message: 'Please Input Name', trigger: 'none' }]
          }
        },
        activeTab: 'activities'
      }
    },
    components: {
      activities,
      activityAuditReasonsForChange
    },
    methods: {
      ...mapActions('managedLists/activityAuditTypes/', ['GET_ACTIVITY_AUDIT_TYPES', 'POST_ACTIVITY_AUDIT_TYPE', 'DELETE_ACTIVITY_AUDIT_TYPE', 'PUT_ACTIVITY_AUDIT_TYPE']),
      ...mapActions('managedLists/activityAuditActivities/', ['GET_ACTIVITY_AUDIT_ACTIVITIES']),
      ...mapActions('managedLists/activityAuditReasonsForChange/', ['GET_ACTIVITY_AUDIT_REASONS_FOR_CHANGE']),
      ...mapMutations('dropdowns/', ['REMOVE_CACHED_DROPDOWN']),
      async initialize(route) {
        this.loading = true
        try {
          await Promise.all([this.GET_ACTIVITY_AUDIT_TYPES(), this.GET_ACTIVITY_AUDIT_ACTIVITIES(), this.GET_ACTIVITY_AUDIT_REASONS_FOR_CHANGE()])
        } catch (err) {
          console.log(err)
        }
        this.loading = false
      },
      closeNewActivityAuditTypePopover() {
        const popper = this.$refs.newActivityAuditTypePopover
        if (popper) {
          this.addActivityAuditTypeForm.name = null
          this.addActivityAuditTypeForm.description = null
          popper.doDestroy()
          popper.doClose()
        }
      },
      drilldown(props) {
        props.row.selected = !props.row.selected
        const index = this.activityAuditTypes.findIndex(x => x.activityAuditTypeId === props.row.activityAuditTypeId)
        this.$set(this.activityAuditTypes, index, props.row)

        this.$refs.activityAuditTypesGrid.toggleChildRow(props.row.activityAuditTypeId)
      },
      openDrilldownTab(props, tab) {
        this.activeTab = tab
        if (!props.row.selected) {
          props.row.selected = true
          const index = this.activityAuditTypes.findIndex(x => x.activityAuditTypeId === props.row.activityAuditTypeId)
          this.$set(this.activityAuditTypes, index, props.row)
          this.$refs.activityAuditTypesGrid.toggleChildRow(props.row.activityAuditTypeId)
        }
      },
      /** Match activityAuditReasonsForChange.vue reasonsForSelectedType — junction is on each reason's activityAuditTypeIds. */
      reasonsCountForType(row) {
        const typeId = row && row.activityAuditTypeId
        if (typeId == null) return 0
        const reasons = this.activityAuditReasonForChanges || []
        return reasons.filter(r => {
          const ids = r.activityAuditTypeIds || []
          return ids.includes(typeId)
        }).length
      },
      resetDropdowns() {
        this.REMOVE_CACHED_DROPDOWN('activityAuditTypesIP')
        this.REMOVE_CACHED_DROPDOWN('activityAuditTypesOP')
        this.REMOVE_CACHED_DROPDOWN('activityAuditTypesAMB')
        this.REMOVE_CACHED_DROPDOWN('activityAuditTypesPro')
      },
      addType(refName) {
        this.$refs[refName].validate(async valid => {
          if (valid) {
            try {
              this.loading = true

              const payload = {
                type: {
                  name: this.addActivityAuditTypeForm.name,
                  description: this.addActivityAuditTypeForm.description,
                  isInpatient: false,
                  isOutpatient: false,
                  isAmbulatory: false,
                  isPro: false,
                  isInactive: false,
                  activities: []
                }
              }

              await this.POST_ACTIVITY_AUDIT_TYPE(payload)
              this.resetDropdowns()

              this.$refs[refName].resetFields()
              this.closeNewActivityAuditTypePopover()
              this.loading = false
              this.$message({
                message: 'Activity Audit Added',
                type: 'success'
              })
            } catch (err) {
              this.loading = false
              this.$message({
                message: `Error Adding Activity Audit: ${err.message}`,
                type: 'error'
              })
            }
          }
        })
      },
      async updateType(type) {
        const index = this.activityAuditTypes.findIndex(x => x.activityAuditTypeId === type.activityAuditTypeId)
        this.$set(this.activityAuditTypes, index, type)

        try {
          this.loading = true
          await this.PUT_ACTIVITY_AUDIT_TYPE(type)
          this.resetDropdowns()
          this.loading = false
          this.$message({
            message: 'Activity Audit Saved',
            type: 'success'
          })
        } catch (err) {
          this.loading = false
          this.$message({
            message: `Error Editing Activity Audit: ${err.message}`,
            type: 'error'
          })
        }
      },
      async deleteType(type) {
        await this.$confirm(`Permanently delete ${type.name}?  If it has been used on records it will be marked inactive instead.`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        try {
          this.loading = true
          await this.DELETE_ACTIVITY_AUDIT_TYPE(type)
          this.resetDropdowns()
          this.loading = false
          this.$message({
            message: 'Activity Audit Removed',
            type: 'success'
          })
        } catch (err) {
          this.loading = false
          this.$message({
            message: `Error Deleting Activity Audit: ${err.message}`,
            type: 'error'
          })
        }
      }
    },
    computed: {
      ...mapState('managedLists/activityAuditTypes/', ['activityAuditTypes']),
      ...mapState('managedLists/activityAuditReasonsForChange/', ['activityAuditReasonForChanges']),
      ...mapState('user/', ['currentTenantGuid'])
    },
    watch: {
      currentTenantGuid() {
        this.initialize(this.$route)
      }
    },
    created: function() {
      this.initialize(this.$route)
    }
  }
</script>

<style scoped>
  .topMargin {
    margin: 10px 0px 0px 0px;
  }

  >>> .drilldown {
    min-width: 200px;
  }

  .drilldown-cell {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .drilldown-toggle {
    color: #337ab7;
    cursor: pointer;
    line-height: 1;
  }

  .drilldown-tag {
    padding: 5px 5px 15px;
    cursor: pointer;
  }

  >>> .el-tabs__item {
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }

  >>> .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  >>> .VueTables__child-row-toggler--closed::before {
    content: '+';
  }

  >>> .VueTables__child-row-toggler--open::before {
    content: '-';
  }
</style>
